import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import {
	ICreateSubcategoryContext,
	CreateSubcategoryContext,
} from '../../../../createSubcategoryState/createSubcategoryContext';
import { CustomerSelect } from './components/CustomerSelect';
// import { RestaurantsMultipleSelect } from './components/RestaurantsMultipleSelect';
import { RestaurantsByCategoryMultipleSelect } from './components/RestaurantsByCategoryMultipleSelect';
import { NameSubcategoryInput } from './components/NameSubcategoryInput';
import { CategorySelect } from './components/CategorySelect';
import { HasSchedulePriorityCheckBox } from './components/HasSchedulePriorityCheckBox';
import { ActivationScheduleInput } from './components/ActivationScheduleInput';
import { DeactivationScheduleInput } from './components/DeactivationScheduleInput';
import CronGenerator from 'components/CronGenerator/CronGenerator';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';
import { BtnBlock } from './components/BtnBlock';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setIDCustomer,
		setFetchedCustomers,
		setIDsRestaurant,
		setFetchedRestaurants,
		setFetchedCategories,
		setIDCategory,
		changeNameOfSubcategory,
		toggleHasSchedulePriority,
		setFetchedTranslations,
		setTranslationTab,
		changeNameTranslation,
		changeActivationSchedule,
		changeDeactivationSchedule,
		fileId,
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		IDSelectedCategory,
		nameOfSubcategory,
		hasSchedulePriority,
		activationSchedule,
		deactivationSchedule,
		translations,
		defaultCustomerLanguage,
		selectedTranslationTab,
	} = useContext<ICreateSubcategoryContext>(CreateSubcategoryContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			IDSelectedCustomer,
			IDsSelectedRestaurant,
			IDSelectedCategory,
			nameOfSubcategory,
			hasSchedulePriority,
			activationSchedule,
			deactivationSchedule,
		});
	}, [
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		IDSelectedCategory,
		nameOfSubcategory,
		hasSchedulePriority,
		activationSchedule,
		deactivationSchedule,
	]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		setDataForSubmit({
			name: nameOfSubcategory,
			customerId: IDSelectedCustomer ? IDSelectedCustomer : '',
			categoryId: IDSelectedCategory ? IDSelectedCategory : '',
			fileId: fileId,
			translations,
			overrideScheduleAvailability: hasSchedulePriority,
			activationCron: activationSchedule || null,
			deactivationCron: deactivationSchedule || null,
			restaurantIds: IDsSelectedRestaurant,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<NameSubcategoryInput changeNameOfSubcategory={changeNameOfSubcategory} />
					<CustomerSelect
						setIDCustomer={setIDCustomer}
						setFetchedCustomers={setFetchedCustomers}
						IDSelectedCustomer={IDSelectedCustomer}
					/>
					<CategorySelect
						setFetchedCategories={setFetchedCategories}
						setIDCategory={setIDCategory}
						customerId={IDSelectedCustomer}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="translationsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<MenuTranslationForm
						className={style.translationForm}
						setFetchedTranslations={setFetchedTranslations}
						setTranslationTab={setTranslationTab}
						changeNameTranslation={changeNameTranslation}
						isShowLanguageName={false}
						IDSelectedCustomer={IDSelectedCustomer}
						translations={translations}
						selectedTranslationTab={selectedTranslationTab}
						nameLabel="nameSubcategoryLabel"
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="scheduleHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<HasSchedulePriorityCheckBox
						toggleHasSchedulePriority={toggleHasSchedulePriority}
						hasSchedulePriority={hasSchedulePriority}
					/>
					<div className={style.row}>
						<ActivationScheduleInput changeActivationSchedule={changeActivationSchedule} />
						<DeactivationScheduleInput changeDeactivationSchedule={changeDeactivationSchedule} />
					</div>
					<CronGenerator />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantListHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					{/* <RestaurantsMultipleSelect
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
						IDSelectedCustomer={IDSelectedCustomer}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/> */}
					<RestaurantsByCategoryMultipleSelect
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
						IDSelectedCategory={IDSelectedCategory}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};
